import { constants } from "@layout";
import styled from "styled-components";

export const Container = styled.div`
  margin-left: ${constants.divPadding}px;
  width: 45px;
  cursor: pointer;
`;

export const Placeholder = styled.div`
  margin-left: ${constants.divPadding}px;
  width: 45px;
`;
